/**
 * The action bar shown above the dock received table. Includes a search field and
 * filters to help find shipments.
 */

import React from "react";
import PropTypes from "prop-types";
import { TableActionBar } from "@amzn/meridian/table";
import Row from "@amzn/meridian/row";
import Heading from "@amzn/meridian/heading";
import Text from "@amzn/meridian/text";
import Button from "@amzn/meridian/button";
// import usePageLayoutContentRectangle from "../../hooks/use-page-layout-content-rectangle";
import dockReceivedPropType from "../../prop-types/dock-received";
import CsvDownloader from 'react-csv-downloader';
import { getSummaryQuantity } from "../../utilities/parent-child-conversion";

const NetworkLoadSlaActionBar = props => {
    const { dockReceived, totalNYR } = props
    const Wrapper = Row;
    // const { width: contentWidth = 1200 } = usePageLayoutContentRectangle()
    // const mobile = contentWidth < 600


    const csvColumns = ["warehouseId", "loadType", "source", "loadId", "timePastSLA", "tempZone", "actualArrivalParsed", "dockReceivedParsed",
        "lastDockReceiveBy", "firstReceiveTimeParsed", "confirmedUnits", "asrsConfirmedUnits", "asrsConfirmedUnitsPercent", "receivedUnits", "asrsReceivedUnits", "nyrnys",
        "receiveStatus", "actualReceiveType", "shipmentValidity", "progress", "dwellDays", "stockSla", "sla", "suppression"
    ]

    return (
        <Wrapper widths="fill">
            <TableActionBar alignmentHorizontal="justify">
                <Row spacing="200">
                    <Row>
                        <Heading level={6}>Total NYR/NYS Past SLA</Heading>
                        <Text>{totalNYR.toLocaleString()}</Text>
                    </Row>
                </Row>
                <Row spacing="200">
                    <CsvDownloader
                        datas={dockReceived.map(data => {
                            // Calculate timePastSLA for CSV export
                            const slaDeadline = data.lastDockReceiveTime + ((data.sla ? Math.min(data.sla, 24) : 24) * 60 * 60 * 1000);
                            const timePastSLA = Date.now() - slaDeadline;
                            const hours = Math.floor(timePastSLA / (1000 * 60 * 60));
                            const minutes = Math.floor((timePastSLA % (1000 * 60 * 60)) / (1000 * 60));
                            const timePastSLAFormatted = `${hours.toString().padStart(2, '0')}:${minutes.toString().padStart(2, '0')}`;

                            // Optimized quantity calculations - batch process all quantities at once
                            const quantityMappings = [
                                ['confirmedUnits', 'childConfirmedUnits'],
                                ['asrsConfirmedUnits', 'childAsrsConfirmedUnits'],
                                ['receivedUnits', 'childReceivedUnits'],
                                ['asrsReceivedUnits', 'childAsrsReceivedUnits'],
                                ['nyrnys', 'childNyrnys']
                            ];

                            const convertedQuantities = Object.fromEntries(
                                quantityMappings.map(([parentField, childField]) => [
                                    parentField,
                                    getSummaryQuantity(data, parentField, childField)
                                ])
                            );

                            // Create enhanced data object with calculated values
                            const enhancedData = {
                                ...data,
                                timePastSLA: timePastSLAFormatted,
                                ...convertedQuantities
                            };

                            return Object.fromEntries(csvColumns.map(key => [key, enhancedData[key]]));
                        })}
                        filename="network-sla"
                        extension=".csv"
                    >
                        <Button>CSV</Button>
                    </CsvDownloader>
                </Row>
            </TableActionBar>
        </Wrapper>
    )
}

NetworkLoadSlaActionBar.propTypes = {
    stick: PropTypes.bool.isRequired,
    dockReceived: PropTypes.arrayOf(dockReceivedPropType),
    totalNYR: PropTypes.number.isRequired,
}

export default NetworkLoadSlaActionBar
